export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 2_03.b555d65d.jpg";